import { INonCompactXMLData } from './interface';

export const XML_NODE_PADDING = 26;
export const XML_NODE_VIRTUALIZED_DEFAULT_HEIGHT = 24;
export const TAG_OFFSET = 24;
export const LINE_NUMBER_OFFSET = 55;

export const ECompactXMLDataType = {
	element: 'element',
	text: 'text',
} as const;

export const SELF_CLOSING_ELEMENT = [{ type: 'text', text: '' } as INonCompactXMLData];
